module.exports = __webpack_public_path__ + "img/geonorge.e4c8d04e.jpg";